/**
 * Destino de una notificación de plataforma al hacer clic.
 * Devuelve null si falta el dato en metadata: la notificación se marca como
 * leída igual, pero no se navega a una ruta con `undefined`.
 */
export const getPlatformNotificationTarget = (
  type: string,
  metadata: Record<string, unknown> | null,
): string | null => {
  const gymPublicId =
    typeof metadata?.gymPublicId === "string" ? metadata.gymPublicId : null;

  switch (type) {
    case "APP_BANNER_PENDING":
      return "/admin/app-banners";
    case "GYM_SUBSCRIPTION_EXPIRING":
    case "GYM_SUBSCRIPTION_EXPIRED":
      return gymPublicId ? `/admin/subscriptions/${gymPublicId}` : null;
    case "GYM_CREATED":
      return gymPublicId ? `/admin/gym/${gymPublicId}` : null;
    default:
      return null;
  }
};
